import { mobileApiClient } from './mobileApiClient';
import type { MonetaryPrecisionResponse } from '@/utils/monetaryPrecision';

export const monetaryPrecisionService = {
  get: async (): Promise<MonetaryPrecisionResponse> => {
    const { data } = await mobileApiClient.get<MonetaryPrecisionResponse>(
      '/api/v1/monetary-precision',
    );
    return data;
  },
};
